import styled from "styled-components";

export const HomeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  position: relative;
`;

export const HomeInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-bottom: 60px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const HomeHeaderWrapper = styled.div<{
  isLogin: boolean;
  inset: number | null;
}>`
  background: ${(p) => (p.isLogin ? "#000" : "#fff")};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 65px;
  padding-top: ${(p) => (p.inset ? `${p.inset + 8}px` : "8px")};
`;

export const HomeHeaderLeft = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;

  > .name {
    font-weight: 700;
    font-size: 18px;
    color: #fff;
  }
  > .welcome {
    font-weight: 600;
    font-size: 16.45px;
    color: #767678;
  }
  > .login {
    font-weight: 500;
    font-size: 16px;
    color: #767678;
  }
`;

export const HomeHeaderRight = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 5px;

  > .alarm {
    position: relative;
    > .icon {
      top: 3px;
      right: 3px;
      position: absolute;
      width: 5px;
      height: 5px;
    }
  }

  img {
    width: 29px;
    height: 29px;
  }
`;
